import { render } from "./AddUserToProjectForm.vue?vue&type=template&id=f8de70f8&scoped=true&ts=true"
import script from "./AddUserToProjectForm.vue?vue&type=script&lang=ts"
export * from "./AddUserToProjectForm.vue?vue&type=script&lang=ts"

import "./AddUserToProjectForm.vue?vue&type=style&index=0&id=f8de70f8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8de70f8"]])

export default __exports__